export const EDENRED_COUNTRY_CONFIG = {
  countryList: [
    'PH',
    'IT',
    'ZA',
    'LU',
    'BE',
    'NL',
    'PT',
    'HU',
    'GR',
    'TR',
    'HK',
    'BR',
    'MU',
    'JP',
    'FR',
    'CO',
    'AR',
    'CL',
    'UY',
    'PE',
    'EC',
    'MX',
    'SE',
    'DK',
    'NO',
    'MY',
    'SG',
    'IE',
    'PY',
    'CZ',
    'SK',
    'ES',
    'TW',
    'AU',
    'NZ',
    'CA',
    'IL',
    'RO',
    'PL',
    'GB',
    'BA',
    'EE',
    'LV',
    'LT',
    'MD',
    'CN',
    'BW',
    'MZ',
    'ZM',
    'ZW',
    'BG'
  ]
};
